module.exports = __webpack_public_path__ + "img/close.49de6616.svg";